import { z } from "zod";
import RefurbishmentStart from "@/pages/RefurbishmentStart";
import type { ModuleProps } from "../types";

export const preTriageMarketPriceConfig = z.object({
  skipIfCachedDays: z.number().int().min(0).default(30),
});
export type PreTriageMarketPriceConfig = z.infer<typeof preTriageMarketPriceConfig>;

export function PreTriageMarketPriceModule(_props: ModuleProps<PreTriageMarketPriceConfig>) {
  return <RefurbishmentStart />;
}
